/* global lazyload */
import 'lazyload';

import Abstract from './abstract';
import { onSendGTag } from './module';
import initCompanyPromotionBanner from '../shared/companyPromotionBanner';
import initMangaInterstitial from '../shared/mangaInterstitial';
import { insertInreadAd } from '../shared/inreadAdPlacement';

const lazyloadDescriptionImage = () => {
  const imagesLazyload = document.querySelectorAll('.trill-description .image-block .image-block__image');

  lazyload(imagesLazyload);
};

const onSendReadMoreContinueGTag = () => {
  onSendGTag('タップ', {
    event_category: '続きを読む',
    event_label: 'タップ',
    non_interaction: true,
  });
};

const onSendOriginalLinkGTag = (e) => {
  const link = e.currentTarget.getAttribute('href');

  onSendGTag('タップ', {
    event_category: '元記事を読む',
    event_label: 'タップ',
    link_url: link,
  });
};

const onSendPVBoostLinkGTag = (e) => {
  const link = e.currentTarget.getAttribute('href');

  onSendGTag('タップ', {
    event_category: 'スポコン救済枠',
    event_label: 'タップ',
    link_url: link,
  });
};

const onSendMediumRelatedArticleLinkGTag = (e) => {
  const title = e.currentTarget.dataset.gaMediumRelatedArticleTitle;
  const link = e.currentTarget.getAttribute('href');

  onSendGTag('タップ', {
    event_category: 'メディア関連記事枠',
    event_label: title,
    link_url: link,
  });
};

const onSendRankingLinkGTag = (e, index) => {
  const link = e.currentTarget.getAttribute('href');
  const isManagementRanking = e.currentTarget.classList.contains('js-article-detail-management-ranking-link');
  const eventCategory = isManagementRanking ? '管理カテゴリランキング' : 'ランキング';

  onSendGTag('タップ', {
    event_category: eventCategory,
    event_label: index,
    link_url: link,
  });
};
const onSendRelatedArticleLinkGTag = (e) => {
  const title = e.currentTarget.dataset.gaRelatedArticleTitle;
  const link = e.currentTarget.getAttribute('href');

  onSendGTag('タップ', {
    event_category: 'あなたにおすすめの記事',
    event_label: title,
    link_url: link,
  });
};

const onSendClickArticleImageLinkGTag = (e) => {
  const link = e.currentTarget.getAttribute('href');

  onSendGTag('タップ', {
    event_category: '記事説明画像',
    event_label: 'タップ',
    link_url: link,
  });
};

const onSendClickMangaCreatorDetailLinkGTag = (e) => {
  const link_url = e.currentTarget.getAttribute('href');

  onSendGTag('タップ', {
    event_category: '作品をもっと見る',
    event_label: 'タップ',
    link_url,
  });
};

// SP/tablet — Rise direct interstitial tag, chosen by OS (iOS vs else=Android).
const injectRiseInterstitial = () => {
  const isIOS = /iP(hone|ad|od)/i.test(navigator.userAgent);
  const adu = isIOS ? 'ADU-HELC43TB' : 'ADU-7DCA0HO2'; // iOS 118505 / Android 118504
  const containerId = `ads-${adu}`;

  // Idempotent: a bfcache-restored page keeps its already-injected container, so skip re-injecting.
  if (document.getElementById(containerId)) return;

  const container = document.createElement('div');
  container.id = containerId;
  document.body.appendChild(container);

  const script = document.createElement('script');
  script.text = `(function(w,d,s,i){w.adunitlength?w.adunitlength.push('${adu}'):w.adunitlength=['${adu}'];`
    + 'var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;'
    + 'j.src=\'https://rise.enhance.co.jp/adu.js?id=\'+i+\'&matwName=matw_uuid\''
    + '+\'&clientTime=\'+(new Date()).getTime();'
    + `f.parentNode.insertBefore(j,f);})(window,document,'script','${adu}');`;
  document.body.appendChild(script);
};

export default class ArticleDetailView extends Abstract {
  init() {
    this.getElement();

    this.addEvent();

    this.addGAM();

    this.setCompanyPromotionPattern();

    initMangaInterstitial(injectRiseInterstitial);
  }

  getElement() {
    this.headerOverlay = document.querySelector('.js-header-overlay-ads');

    this.descriptionOuter = document.querySelector('.js-article-description-outer');
    this.readMoreOuter = document.querySelector('.js-article-readmore-outer');

    this.pvboostLink = Array.prototype.slice.call(document.querySelectorAll('.js-article-pvboost-link'));

    this.originalLink = document.querySelector('.js-article-original-link');
    this.relatedMediumArticleLinks = Array.prototype.slice.call(document.querySelectorAll('.js-medium-related-article-link'));

    this.rankingLinks = document.querySelectorAll('.js-article-detail-ranking-link, .js-article-detail-management-ranking-link');

    this.relatedArticleLinks = Array.prototype.slice.call(document.querySelectorAll('.js-related-article-link'));

    this.ArticleDetailContainer = document.querySelector('.js-article-detail-container');
    this.articleDescriptionContainer = document.querySelector('.js-article-description-outer')
      || document.querySelector('.js-sponsored-article-description-outer');

    this.mangaCreatorDetailLink = document.querySelector('.js-article-detail-manga-creator-detail-link');
  }

  setCompanyPromotionPattern() {
    const data = window.currentCompanyPromotionPatternData;
    if (!data || !data.gaValue) return;

    const el = document.querySelector('.js-company-promotion-pattern');
    if (!el) return;

    initCompanyPromotionBanner(el, onSendGTag, data.gaValue);
  }

  addEvent() {
    if (this.descriptionOuter && this.readMoreOuter) this.readMoreOuter.addEventListener('click', this.onClick.bind(this));

    if (this.pvboostLink) {
      this.pvboostLink.forEach((el) => {
        el.addEventListener('click', onSendPVBoostLinkGTag);
      });
    }

    if (this.originalLink) this.originalLink.addEventListener('click', onSendOriginalLinkGTag);

    if (this.relatedMediumArticleLinks) {
      this.relatedMediumArticleLinks.forEach((el) => {
        el.addEventListener('click', onSendMediumRelatedArticleLinkGTag);
      });
    }

    if (this.rankingLinks) {
      this.rankingLinks.forEach((el, index) => {
        el.addEventListener('click', (e) => {
          const indexNumber = index + 1;
          onSendRankingLinkGTag(e, indexNumber);
        });
      });
    }

    if (this.relatedArticleLinks) {
      this.relatedArticleLinks.forEach((el) => {
        el.addEventListener('click', onSendRelatedArticleLinkGTag);
      });
    }

    const pageviewContent = (window.dataLayer && window.dataLayer[0] && window.dataLayer[0].pageviewContent) || {};
    if (this.articleDescriptionContainer) {
      const excludeArticlePhoto = this.articleDescriptionContainer.dataset.excludeArticlePhoto === 'true';
      // Prefer server-rendered article id; dataLayer is absent when GA tracking is disabled (e.g. preview)
      const articleId = this.articleDescriptionContainer.dataset.articleId || pageviewContent.article_id;
      this.articleDescriptionContainer.querySelectorAll('.trill-description img').forEach((imageElement, index) => {
        if (excludeArticlePhoto) {
          // eslint-disable-next-line no-param-reassign
          imageElement.style.visibility = 'visible';
          return;
        }

        const newImageLinkElement = document.createElement('a');

        newImageLinkElement.setAttribute('rel', 'nofollow');

        // eslint-disable-next-line no-param-reassign
        imageElement.style.visibility = 'visible';
        newImageLinkElement.href = `/articles/${articleId}/photos/${index + 1}`;
        newImageLinkElement.className = 'image-block__link-container';
        newImageLinkElement.innerHTML = `
          ${imageElement.outerHTML}
        `;

        imageElement.insertAdjacentElement('beforebegin', newImageLinkElement);
        // eslint-disable-next-line no-param-reassign
        imageElement.style.display = 'none';
        newImageLinkElement.addEventListener('click', (event) => {
          onSendClickArticleImageLinkGTag(event);
        });
      });
      lazyloadDescriptionImage();
    }

    if (this.mangaCreatorDetailLink) this.mangaCreatorDetailLink.addEventListener('click', onSendClickMangaCreatorDetailLinkGTag);
  }

  onClick() {
    this.removeReadMore();

    onSendReadMoreContinueGTag();
  }

  removeReadMore() {
    this.descriptionOuter.classList.remove('articleDetail-MainContent_Body--Hidden');

    this.readMoreOuter.remove();

    window.dispatcher.emit('READ_MORE_ARTICLE');
  }

  addGAM() {
    const adHtml = '<div id="div-gpt-ad-1622988823590-0"></div>';
    insertInreadAd(this.ArticleDetailContainer, adHtml);
  }
}
